import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=fa911292&"
import script from "./GlobalSearch.vue?vue&type=script&lang=js&"
export * from "./GlobalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa911292')) {
      api.createRecord('fa911292', component.options)
    } else {
      api.reload('fa911292', component.options)
    }
    module.hot.accept("./GlobalSearch.vue?vue&type=template&id=fa911292&", function () {
      api.rerender('fa911292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/GlobalSearch.vue"
export default component.exports